import React from 'react';
import PropTypes from 'prop-types';
import { findIndex, map, forEach, includes, find } from 'lodash';
import { LocaleService, UrlService } from '@sm360/widget-commons-core-services';
import { AnalyticsService, TRACKING_TAGS as TAGS } from '@sm360/widget-commons-general';

import BODY_STYLES from 'inventory-listing/constants/bodyStyle.js';

import MetaDataModel from 'inventory-listing/models/MetaDataModel.js';

import Bodystyle from 'inventory-listing/components/ListingFilters/Components/ListingFiltersBodyStyle/BodyStyle.jsx';

class ListingFiltersBodyStyle extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            bodystyles: this.mapBodyStyle(props.bodystyles),
        };

        this.handleChange = this.handleChange.bind(this);
        this.resetSettings = this.resetSettings.bind(this);
    }

    componentWillReceiveProps(newProps) {
        this.setState({
            bodystyles: this.mapBodyStyle(newProps.bodystyles),
        });
    }

    mapBodyStyle(bodystyles) {
        const mappedBodyStyles = [];
        const queryParamFramestyle = UrlService.getUrlParameter('frameStyleTypes');
        const selectedFramestyle = queryParamFramestyle ? queryParamFramestyle.split(',') : [];

        forEach(bodystyles, (bodystyle) => {
            const mappedBodyStyle = find(BODY_STYLES, (value) => {
                return includes(value.codes, parseInt(bodystyle.code, 10));
            });

            if (mappedBodyStyle) {
                const isAlreadyDefined =
                    findIndex(mappedBodyStyles, (value) => {
                        return value.group === mappedBodyStyle.group;
                    }) !== -1;

                if (!isAlreadyDefined) {
                    mappedBodyStyles.push(
                        bodystyle
                            .set('code', bodystyle.code)
                            .set('class', mappedBodyStyle.iconClass)
                            .set('group', mappedBodyStyle.group)
                            .set('label', LocaleService.t(`BODY_STYLES.${mappedBodyStyle.group}`))
                            .set('isSelected', includes(selectedFramestyle, bodystyle.code?.toString()))
                    );
                }
            }
        });

        return mappedBodyStyles;
    }

    resetSettings(event) {
        event.preventDefault();

        const bodystyles = map(this.state.bodystyles, (bodystyle) => {
            return bodystyle.set('isSelected', false);
        });

        this.props.updateVehicleCriteria(bodystyles, 'frameStyleTypes', false);

        this.setState({
            bodystyles,
        });
    }

    handleChange(group) {
        const bodystyles = this.state.bodystyles;
        const index = findIndex(bodystyles, { group });

        bodystyles[index] = bodystyles[index].set('isSelected', !bodystyles[index].isSelected);

        if (bodystyles[index].isSelected) {
            AnalyticsService.ga4Trigger(TAGS.BODY_STYLE(bodystyles[index].label));
        }

        this.props.updateVehicleCriteria(bodystyles, 'frameStyleTypes', bodystyles[index].isSelected);

        this.setState({
            bodystyles,
        });
    }

    render() {
        const bodyStyles = this.state.bodystyles.map((bodystyle) => (
            <Bodystyle bodystyle={bodystyle} key={bodystyle.code} handleChange={this.handleChange} />
        ));

        return (
            <div className="listing-used-filters-bloc listing-used-filters-bodystyle">
                <div className="listing-used-filters-title sr-text is-bold">
                    {LocaleService.t('FILTERS.BODY_STYLE')}
                    <button className="listing-used-filters-clear sr-link is-regular" onClick={this.resetSettings}>
                        {LocaleService.t('BUTTONS.CLEAR')}
                    </button>
                </div>
                <div className="listing-used-bodystyles">{bodyStyles}</div>
            </div>
        );
    }
}

ListingFiltersBodyStyle.defaultProps = {
    bodystyles: [],
};

ListingFiltersBodyStyle.propTypes = {
    bodystyles: PropTypes.arrayOf(PropTypes.instanceOf(MetaDataModel)),
    updateVehicleCriteria: PropTypes.func.isRequired,
};

ListingFiltersBodyStyle.displayName = 'ListingFiltersBodyStyle';

export default ListingFiltersBodyStyle;
